<!-- 促销价格 -->
<template>
  <div>
    <!-- 直降 -->
    <StraightDownPrice
      v-if="allAcvitityInfo.activeType === 1"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <!-- 秒杀 -->
    <SeckillPrice
      v-else-if="allAcvitityInfo.activeType === 2 || allAcvitityInfo.activeType === 3"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <!-- 优惠券 -->
    <CouponPrice
      v-else-if="allAcvitityInfo.activeType === 4"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
    />
    <GroupBuyPrice
      v-else-if="allAcvitityInfo.activeType === 5"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SeckillPrice from '../../seckill/seckillPrice.vue';
import StraightDownPrice from '../../straightDown/straightDownPrice.vue';
import CouponPrice from '../../coupon/couponPrice.vue';
import GroupBuyPrice from './groupBuy/GroupBuyPrice.vue';
import { reqproductDetailDiscount } from '../../../api/courseDetail/courseAcvitity/index';
// import { reqCurrentTime } from '../../../api/courseDetail/index';
import { replaceHyphens } from '../../../utils/tools';

export default {
  data() {
    return {
      salePrice: 0,
      allAcvitityInfo: {}, // 产品详情页所有的活动数据
      activeType: 0, // 活动类型  0无单品促销活动  1 直降 2 限时秒杀 3 限量秒杀  4优惠券  5 拼团 6分享
      nowAcvitity: {}, //  当前展示的活动信息
      currentTime: 0,
    };
  },
  components: {
    SeckillPrice,
    StraightDownPrice,
    CouponPrice,
    GroupBuyPrice,
  },
  props: {},
  computed: {
    ...mapState(['courseBaseData', 'productSku', 'userInfo']),
  },
  watch: {
    productSku(data) {
      this.getAcvitity();
      // this.getServerTime();
      this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
    },
    userInfo() {
      if (!this.productSku.productSkuId) return;
      // 登录成功后更新优惠券列表的领取状态（针对已领取的优惠券）
      this.getAcvitity();
      // this.getServerTime();
    },
    courseBaseData(data) {
      // 默认取产品的价格
      this.salePrice = data.sellPrice;
    },
  },
  mounted() {
  },
  methods: {
    // 服务器时间
    // async getServerTime() {
    //   const current = await reqCurrentTime();
    //   this.currentTime = current.data
    //     ? new Date(replaceHyphens(current.data)).getTime()
    //     : new Date().getTime();
    // },
    // 查询所有活动，优惠券和单品折扣活动同时存在的时候，已单品折扣为主
    async getAcvitity() {
      if (!this.productSku.productSkuId) return;
      const res = await reqproductDetailDiscount({
        endPoint: this.$root.miniprogram?8:this.$root.isApp?2:4,
        fitPlatform: 1,
        productId: this.$route.query.courseId,
        skuId: this.productSku.productSkuId,
        categoryId: this.courseBaseData.productCategoryId,
      });
      // const res = { code: 10001, msg: '促销查询优惠信息异常', data: null, errorData: null };
      let activeType = 0;
      let nowAcvitity = {};
      if (res.code === 0) {
        this.currentTime = res.currentTime
          ? new Date(replaceHyphens(res.currentTime)).getTime()
          : new Date().getTime();
        const {
          productDetailSinglePromotionResp,
          couponDetailVO,
          productGroupActivityDiscount,
        } = res.data;
        this.allAcvitityInfo = res?.data;
        // 秒杀,直降
        if (productDetailSinglePromotionResp) {
          let state = 0;
          const { stockType, stockNum } = productDetailSinglePromotionResp;
          activeType = productDetailSinglePromotionResp.promotionLabel;
          if (!productDetailSinglePromotionResp.startTime) {
            activeType = 0;
          } else if (
            productDetailSinglePromotionResp.showTime
            && new Date(replaceHyphens(productDetailSinglePromotionResp.showTime)).getTime()
              > this.currentTime
          ) {
            // 未到活动展示时间
            activeType = 0;
          } else if (
            new Date(replaceHyphens(productDetailSinglePromotionResp.startTime)).getTime()
            > this.currentTime
          ) {
            // 未开始
            state = 0;
          } else if (
            this.currentTime
              > new Date(replaceHyphens(productDetailSinglePromotionResp.endTime)).getTime()
            || (stockType === 2 && stockNum === 0)
          ) {
            // 已结束  //限量秒杀活动库存为0，隐藏活动
            state = 2;
            activeType = 0;
          } else {
            // 进行中
            state = 1;
          }
          nowAcvitity = productDetailSinglePromotionResp;
          Object.assign(productDetailSinglePromotionResp, {
            stockNum: stockType === 1 ? this.productSku.availableStock : stockNum,
            state,
          });
        } else {
          activeType = 0;
        }
        // 拼团活动
        if (productGroupActivityDiscount) {
          activeType = 5;
          nowAcvitity = productGroupActivityDiscount;
        }
        // 优惠券 免费课不展示券后价格
        if (
          activeType === 0
          && couponDetailVO
          && couponDetailVO.couponId
          && this.productSku.price
        ) {
          nowAcvitity = couponDetailVO;
          activeType = 4;
          Object.assign(couponDetailVO, {
            price: this.salePrice,
            promotionPrice: (this.salePrice - couponDetailVO.couponDiscount).toFixed(2),
          });
        }
        this.activeType = activeType;
        this.nowAcvitity = nowAcvitity;
      }
      Object.assign(this.allAcvitityInfo, { activeType, nowAcvitity });
      this.saveAcvitity();
    },
    // 更新活动状态
    receiveGetActive() {
      // this.getServerTime();
      this.getAcvitity();
    },
    // 活动保存到vuex
    saveAcvitity() {
      this.$store.dispatch('saveAllAcvitity', this.allAcvitityInfo);
    },
  },
};
</script>
